// GENERATED FILE - DO NOT MODIFY

export enum HappeningAttendanceTypeDto {
    InPerson = "InPerson",
    Hybrid = "Hybrid",
    Remote = "Remote",
}